module.exports = __webpack_public_path__ + "static/media/reparacion.3dc92e46.jpg";